import { render } from "./MessageBox.vue?vue&type=template&id=687819ea&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=687819ea&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687819ea"]])

export default __exports__